import { LOGGED_OUT } from 'actions/types';
import { GET_STREAKS_FAILURE, GET_STREAKS_REQUEST, GET_STREAKS_SUCCESS, } from '../actions/types';
export const initialState = {
    summary: undefined,
    months: {},
};
const streaksReducer = (state = initialState, action) => {
    switch (action.type) {
        case LOGGED_OUT:
            return initialState;
        case GET_STREAKS_REQUEST: {
            const { month } = action.extra;
            return {
                ...state,
                months: {
                    ...state.months,
                    [month]: { ...state.months[month], isLoading: true },
                },
            };
        }
        case GET_STREAKS_SUCCESS: {
            const { month } = action.extra;
            const { activeDays, month: _month, ...summary } = action.payload;
            return {
                summary,
                months: {
                    ...state.months,
                    [month]: { isLoading: false, activeDays },
                },
            };
        }
        case GET_STREAKS_FAILURE: {
            const { month } = action.extra;
            return {
                ...state,
                months: {
                    ...state.months,
                    [month]: { ...state.months[month], isLoading: false },
                },
            };
        }
        default:
            return state;
    }
};
export default streaksReducer;
